module.exports = __webpack_public_path__ + "static/ON_POS_LOGO_RGB-1ef388ed61a6ce5aa2d0b7cc3289713c.png";